module.exports = __webpack_public_path__ + "a95182f44334f6d667801d48857da499.svg";